import React from "react";
import DayView from "./DayView";
import WeekView from "./WeekView";

class LiveSchedule extends React.Component {
  state = {
    data: this.props.data.contentData.filter(
      item => item.gist.scheduleEndDate > Date.now()
    ),
    view: "week",
    isToggleAbsolute: false
  };


  componentDidMount = () => {
    const footer = document.querySelector('.footer04')
    const toggle = document.querySelector('.WeekView_changeView')
    const current = document.documentElement
    window.addEventListener('scroll', () => {
      this.setState({
        isToggleAbsolute: current.clientHeight +  window.scrollY >= (current.scrollHeight - (footer.offsetHeight) + toggle.offsetHeight)
      })
    }, false)
  }

  changeView = view => e => {
    const v = view === "week" ? "day" : "week";
    this.setState({ view: v });
  };
  renderView = view => {
    const { data } = this.state;
    if (view === "week") {
      return <WeekView data={data} />;
    }
    if (view === "day") {
      const getTodaysEvents = events => {
        const getDate = timestamp => new Date(timestamp).getDate(),
          today = getDate(Date.now());
        return events.filter(
          ({ gist: { scheduleStartDate } }) =>
            getDate(scheduleStartDate) === today
        );
      };
      const todaysEvents = getTodaysEvents(this.state.data);
      return <DayView data={todaysEvents} />;
    }
  };
  render() {
    const {
        state: { view }
      } = this,
      buttonText = {
        day: "Weekly View",
        week: "Daily View"
      },
      toggleStyles = {
        ...(!this.state.isToggleAbsolute ? 
        { position: 'fixed', bottom: 0 } : 
        { position: 'absolute', bottom: '-30px' }),
      }
    return (
      <div style={{ backgroundColor: "#0d0d0d", display: 'flex', flexDirection: 'column', position: 'relative', minHeight: '100vh' }}>
        <button 
          className="WeekView_changeView" 
          onClick={this.changeView(view)} 
          style={toggleStyles}
        >
          {buttonText[view]}
        </button>
        {this.renderView(view)}
      </div>
    );
  }
}

export default LiveSchedule;